Vendd.Scripts.load(function () {
    'use strict';

    var $form = $('.x-cart-coupon'),
        $formMinimal = $('.x-cart-coupon-minimal'),
        form, formMinimal, cf, formData,
        $submitButton, $clearButton, $input;

    var model = null;

    if ($form.length < 1)
        return;

    var firstRun = true;

    form = $form.get(0);

    formData = {};

    form.loading = function loading (loading) {
        if (loading) {
            $form.addClass('x-loading');
        } else {
            $form.removeClass('x-loading');
        };
    };

    form.propButton = function propButton (enabled) {
        if (enabled) {
            $clearButton.prop('disabled', false).parent().removeClass('x-disabled');
        } else {
            $clearButton.prop('disabled', true).parent().addClass('x-disabled');
        };
    };

    form.show = function show () {
        $form.closest('.js-widget-container').show();
    };

    form.hide = function show () {
        $form.closest('.js-widget-container').hide();
    };

    form.bind = function bind(html) {
        $form.html(html);

        $submitButton = $('.js-submit', $form);
        $clearButton = $('.js-clear-all', $form);
        $input = $('.input-wrapper', $form);

        form.loading(false);

        if (firstRun) {
            $form.removeClass('x-initializing');
            firstRun = false;
        }
    };

    form.reset = function reset() {
        formData.code = "";

        $('input[name="code"]', $form).val("");

        $('.js-error', $form).hide();
        $('.js-success', $form).hide();
    };

    form.submit = function submit () {
        form.loading(true);

        formData.code = omitScriptTag(formData.code);

        Vendd.MessageBus.publishAsync(form, new Vendd.Cart.Messages.ApplyCoupon(formData.code));
    };

    form.applyCouponSuccess = function (response) {
        /* Track Discount Coupon */
        if (typeof fbPixelTracker !== 'undefined' && typeof fbPixelCanTrack !== 'undefined') {
            if (fbPixelTracker && fbPixelTracker.Properties.FacebookPixelId && fbPixelCanTrack) {
                fbq('trackCustom', 'DiscountCoupon', { discount: response.message.data.message.data.code });
            }
        }
        /* END Track Discount Coupon */
        form.reset();
        $.fancybox.close();
    }

    $form.on('keyup', 'input[name]', function (e) {

        if (e.keyCode == 13) {
            e.preventDefault();
            e.stopPropagation();

            $submitButton.click();

            return;
        };

        var $this = $(this);
        var fieldName = $this.attr('name');

        formData[fieldName] = $this.val();
    });

    $form.on('click', '.js-submit', function (e) {
        e.preventDefault();
        e.stopPropagation();

        form.submit();
    });

    $form.on('click', '.js-available-coupons-submit', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var $couponCode = $(this).attr('data-code');
        $('input', $input).val($couponCode);
        formData.code = $couponCode;

        form.submit();

    });

    $form.on('click', '.js-clear-all', function (e) {
        e.preventDefault();
        e.stopPropagation();

        form.loading(true);

        form.reset();

        Vendd.MessageBus.publishAsync(form, new Vendd.Cart.Messages.ClearCoupons());
    });

    $form.on('click', '.js-clear', function (e) {
        e.preventDefault();
        e.stopPropagation();

        Vendd.MessageBus.publishAsync(form, new Vendd.Cart.Messages.ClearCoupon($(this).data('code')));
    });

    if ($formMinimal.length > 0) {
        formMinimal = $formMinimal.get(0);

        formMinimal.bind = function bind(html) {
            $formMinimal.html(html);
        };

        $formMinimal.on('click', '.js-clear', function (e) {
            e.preventDefault();
            e.stopPropagation();

            Vendd.MessageBus.publishAsync(form, new Vendd.Cart.Messages.ClearCoupon($(this).data('code')));
        });
    }

    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Changed, form, function (envelope) {
        model = envelope.message.data.Cart;

        var html = Vendd.Handlebars.parse("cartCouponWidget_A", model);
        form.bind(html);

        if ($formMinimal.length > 0) {
            var htmlMinimal = Vendd.Handlebars.parse("cartCouponWidget_B", model);
            formMinimal.bind(htmlMinimal);
        }

        if (model.IsEmpty) {
            form.hide();
        } else {
            form.show();
        };

        form.reset();

        form.loading(false);
    });

    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.ApplyCouponSuccess, form, form.applyCouponSuccess);

    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Failed, form, function (envelope) {
        var message = envelope.message.data.data.Message;

        if (envelope.message.data.success === true) {
            $('.js-error', $form).hide();
            $('.js-success', $form).text(message).show();

        } else {
            $('.js-success', $form).hide();
            $('.js-error', $form).text(message).show();
            $input.closest('.form-row').addClass('with-error');
        }

        form.loading(false);
    });

});